import { getVal } from "oolib";

export const usePrepareData = ({data, valuePath, labelPath, tooltipLabelsMapping, groupBy}) => {
  // Check if it's breakdown data (array of valuePaths) or simple data
  const isBreakdown = Array.isArray(valuePath);
  
  if (!isBreakdown) {
    // If groupBy is specified, group the data by that field
    if (groupBy && data.length > 0 && groupBy in data[0]) {
      // Group data by the specified field
      const groupedData = {};
      
      data.forEach(item => {
        const groupKey = getVal(item, groupBy) || 'Uncategorized';
        if (!groupedData[groupKey]) {
          groupedData[groupKey] = {
            items: [],
            totalCount: 0
          };
        }
        
        const count = getVal(item, valuePath) || 0;
        groupedData[groupKey].items.push({
          tagId: getVal(item, labelPath),
          display: getVal(item, labelPath),
          _id: Math.random().toString(36).substr(2, 9),
          count: count
        });
        groupedData[groupKey].totalCount += count;
      });
      
      // Convert grouped data to the expected format
      return Object.entries(groupedData).map(([key, value]) => ({
        tagCategory: key,
        totalCountOfAllTagsWithin: value.totalCount,
        tagSpecificCount: value.items
      }));
    } else {
      // Simple case - single category with single values
      return [{
        tagCategory: undefined,
        totalCountOfAllTagsWithin: data.reduce((sum, item) => sum + (getVal(item, valuePath) || 0), 0),
        tagSpecificCount: data.map(item => ({
          tagId: getVal(item, labelPath),
          display: getVal(item, labelPath),
          _id: Math.random().toString(36).substr(2, 9),
          count: getVal(item, valuePath) || 0
        }))
      }];
    }
  } else {
    // For breakdown case, we'll create categories based on the valuePath items
    // Each valuePath becomes a category
    return valuePath.map((path, pathIndex) => {
      const categoryName = tooltipLabelsMapping?.[path] || path;
      const totalCount = data.reduce((sum, item) => sum + (getVal(item, path) || 0), 0);
      
      return {
        tagCategory: categoryName,
        totalCountOfAllTagsWithin: totalCount,
        tagSpecificCount: data
          .map(item => ({
            tagId: getVal(item, labelPath),
            display: getVal(item, labelPath),
            _id: `${pathIndex}-${getVal(item, labelPath)}`,
            count: getVal(item, path) || 0
          }))
          .filter(tag => tag.count > 0) // Only include items with values
      };
    }).filter(category => category.tagSpecificCount.length > 0); // Only include categories with items
  }
};